import { render, staticRenderFns } from "./PageImage.vue?vue&type=template&id=194b47ab"
import script from "./PageImage.vue?vue&type=script&lang=js"
export * from "./PageImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports